import styled from "@emotion/styled";
import { units } from "../../types/units";

export const SupportLayout = styled.div`
  width: 100%;
  padding: 20px;
`;

export const TableHeading = styled.th`
  padding: 10px;
  ${units({
    fontSize: "20px",
    backgroundColor: "lightGrey",
  })};
`;
export const TableRow = styled.tr`
  ${units({
    backgroundColor: "lighterGrey",
  })};
`;

export const TableCell = styled.td`
  padding: 10px;
  ${units({
    fontSize: "16px",
  })};
`;

export const Table = styled.table`
  text-align: left;
  border-collapse: collapse;
  width: 100%;
  font-family: ${(props) => props.theme.fontFamily.primary};
  ${units({
    color: "grey",
    fontSize: "16px",
  })};
`;
